<template>
  <div
    :class="{
      'top-0 w-1px': cell.mode === 'vertical',
      'left-0 h-1px': cell.mode === 'horizontal'
    }"
    :style="myStyle"
    class="absolute bg-grid-cell pointer-events-none z-1"
  />
</template>

<script>
import Grid from '@/roc/grid/Grid';
import {computed} from 'vue';

export default {
  props: {
    cell: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    return {
      myStyle: computed(() => {
        if (props.cell.mode === 'vertical') {
          return 'left:' + props.cell.position + 'px;height:' + (Grid.CELL_COUNT_Y * Grid.CELL_SIZE) + 'px';
        }
        return 'top:' + props.cell.position + 'px;width:' + (Grid.CELL_COUNT_X * Grid.CELL_SIZE) + 'px';
      })
    };
  }
};
</script>
